@if (selectedItem) {
  <mat-form-field appearance="fill" class="small-width">
    <mat-label>{{label}}</mat-label>
    <input type="text" title="Destination Value" matInput disabled value="{{selectedItem.displayName}}" >
    <button matIconButton matSuffix
      (click)="editDestination()"
      matTooltip="Change Destination"
      [attr.aria-label]="'Change Destination'"
      [attr.aria-pressed]="change">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
} @else {
  @if(hasDestinations)
    {
    <mat-form-field appearance="fill">
      <mat-label>{{label}}</mat-label>
      <input type="text"
        placeholder="Select Value..."
        matInput
        [matAutocomplete]="auto"
        [formControl]="destinationFormControl">
        <mat-autocomplete autoActiveFirstOption
          #auto="matAutocomplete"
          (optionSelected)="selectDestination($event.option.value)"
          [displayWith]="displayFnDestination">
          @for (option of destinationsFiltered | async; track option) {
            <mat-option [value]="option" >
              {{option.displayName}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
    @else
    {
    <div class="loading-display" >
      <app-lt-spinner></app-lt-spinner>
    </div>
  }
}
